export const cascadeModalStore = {
    mutations: {
        openCascadeModal() {},
        navigateCascadeModal() {},
    },
};
